export default __webpack_public_path__ + "static/media/FCHO_1.dbbc80ae.png";